import o from "./houseTypeEditDialog.ce.vue2.js";
import t from "./houseTypeEditDialog.ce.vue3.js";
import r from "../../_virtual/_plugin-vue_export-helper.js";
const f = /* @__PURE__ */ r(o, [["styles", [t]]]);
export {
  f as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/house-type-edit-dialog/houseTypeEditDialog.ce.vue.js
// module id = 1297
// module chunks = 67